import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { SemanticError, SemanticSuccess } from '../../color-palette/colors';

interface StatusMessageScreenProps {
  type: 'positive' | 'negative';
  messageHeading?: string;
  messageBody?: string;
}

const StatusMessageScreen: React.FC<StatusMessageScreenProps> = ({
  type,
  messageHeading,
  messageBody,
}) => {
  const isPositive = type === 'positive';

  // Default messages
  const defaultHeading = isPositive 
    ? 'Success!' 
    : 'Access Denied';
  
  const defaultBody = isPositive
    ? 'Your request was processed successfully.'
    : 'This link is no longer accessible or has expired.';

  return (
    <Box
      sx={{
        display: 'grid',
        placeItems: 'center',
        width: '100%',
        height: '100%',
        padding: 3,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        {isPositive ? (
          <CheckCircleIcon
            sx={{
              fontSize: 120,
              color: SemanticSuccess[600],
              mb: 3,
            }}
          />
        ) : (
          <ErrorOutlineIcon
            sx={{
              fontSize: 120,
              color: SemanticError[600],
              mb: 3,
            }}
          />
        )}
        
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          sx={{
            fontWeight: 700,
            mb: 2,
          }}
        >
          {messageHeading || defaultHeading}
        </Typography>
        
        <Typography
          variant="body1"
          sx={{
            maxWidth: '600px',
            color: 'text.secondary',
          }}
        >
          {messageBody || defaultBody}
        </Typography>
      </Box>
    </Box>
  );
};

export default StatusMessageScreen;
